module.exports = __webpack_public_path__ + "static/media/2_en.27f3ac10.png";